import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {isMobile} from 'react-device-detect';

class PhoneNumber extends Component {
  render() {
    const phoneNumberValue = this.props.value;
    let phoneNumberText = phoneNumberValue;

    if(this.props.children !== undefined) {
      phoneNumberText = this.props.children;
    }
    if(isMobile) {
      phoneNumberText = <a href={`tel:${phoneNumberValue}`}>{phoneNumberText}</a>
    }   

    return (
      <span>{phoneNumberText}</span>
    );
  }
}

PhoneNumber.defaultProps= {  
  value: ""
};

PhoneNumber.propTypes = {
  value: PropTypes.string
};

export default PhoneNumber;


// WEBPACK FOOTER //
// ./src/components/PhoneNumber/PhoneNumber.js